<!--
 * @Author: cgh
 * @Date: 2022-08-03 12:44:11
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 18:19:11
 * @Description: 评估成员
-->
<template>
  <!-- 页面头部 Start -->
  <!-- 页面头部 End -->
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-90 o-dialog--lg-90 o-dialog--xl-90 o-dialog-h--85"
    title="评估成员"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <!-- 查询条件 Start -->
    <div
      class="l-page l-page--search"
    >
      <div
        class="l-page__header c-page__header"
      >
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :inline="true"
          label-position="right"
          label-suffix="："
        >
          <el-form-item
            class="c-form__item"
            label="姓名"
            prop="name"
          >
            <el-input
              v-model.trim="filterParams.name"
              class="c-form__input"
              placeholder="姓名"
              clearable
            />
          </el-form-item>
        </el-form>
        <div
          class="c-page__header-btns"
          style="margin-left: 10px;"
        >
          <k-button
            btn-text="查询"
            :auth-type="false"
            type="primary"
            icon="kestrel-icon ki-search"
            @click="init()"
          />
          <k-button
            btn-text="重置"
            :auth-type="false"
            icon="kestrel-icon ki-repeat"
            @click="resetForm()"
          />
          <k-button
            v-if="dlParams.type === 'edit'"
            btn-text="新增"
            :auth-type="true"
            type="success"
            icon="kestrel-icon ki-plus"
            @click="handleDialog('add')"
          />
          <!-- 查询条件表单 End -->
        </div>
      </div>

      <!-- 查询条件 End -->
      <!-- 页面主内容：查询列表 Start -->
      <div
        class="l-page__body l-page--search__body"
      >
        <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
        <!-- table的ref的命名根据业务名称修改 -->
        <k-table
          ref="kTable"
          height="100%"
          :table-column="tableColumn"
          :data="pgcyList.rows"
          :pagination="pgcyList"
          :pagination-show="false"
        >
          <template
            #pgfg="scope"
          >
            <div
              v-if="scope.row.cyId === fd.id && flag"
            >
              <el-input
                v-model="fd.pgfg"
                class="edit-input"
                type="textarea"
                size="small"
                @change="handleSave(scope.row.cyId)"
              />
            </div>
            <span v-else>{{ scope.row.pgfg }}</span>
          </template>
          <el-table-column
            v-if="dlParams.type === 'edit'"
            prop="enabled"
            label="操作"
            width="120"
            align="center"
          >
            <template
              slot-scope="scope"
            >
              <k-button
                btn-text="编辑"
                :auth-type="true"
                type="primary"
                plain
                @click="handleEdit(scope.row)"
              />
              <k-button
                btn-text="删除"
                :auth-type="true"
                type="danger"
                @click="handleDel(scope.row, scope.$index)"
              />
            </template>
          </el-table-column>
        </k-table>
      </div>
    <!-- -->
    </div>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="导出"
        :auth-type="false"
        @click="closeDialog()"
      >
        关闭
      </k-button>
    </div>
    <!--添加评估成员-->
    <addPgcy-dialog
      v-if="showDialogName==='add'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="init()"
    />
  </el-dialog>
</template>

<script>
import { pgcyService } from './pgcy.service.js';
export default {
  name: 'PgcyDialog',
  components: {
    addPgcyDialog: () => import('./addPgcyDialog')
  },
  props: {
    dlParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示

      loading: false, // 页面是否加载
      xmid: '', // 评估项目ID
      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'name', label: '姓名', align: 'left', width: '120', type: 'text' },
        { key: 'zw', label: '职务/职称', align: 'left', minWidth: '80', type: 'text' },
        { key: 'zyzgzsbh', label: '执业资格证书编号', align: 'left', minWidth: '80', type: 'text' },
        { key: 'pgfg', slotName: 'pgfg', label: '评估分工', align: 'left', minWidth: '280', type: 'text' }
      ],
      /* 表格列配置End */
      fd: {
        id: null,
        pgfg: null
      },
      // 查询条件
      filterParams: {
        name: null
      },
      flag: false,
      /* 弹窗 start */
      showDialogName: '',
      dialogParams: {},
      /* 弹窗 end */
      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */
      multipleSelectedRow: [], // 表格选中行（多选）
      pgcyList: {
        rows: [],
        total: 0,
        pageSize: 30,
        pageNo: 0
      }
    };
  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    /**
     * @description: 表格选中行事件（多选）
     * @param {Object} val
     * @return {*}
     */
    handleSelectionChange (val) {
      this.multipleSelectedRow = val;
    },
    // 显示input框
    handleEdit (obj) {
      this.fd = { pgfg: obj.pgfg, id: obj.cyId };
      this.flag = true;
      this.$forceUpdate();
    },
    /**
       * @description: 跳转窗口
       * @author: cgh
       */
    handleDialog (_name) {
      this.showDialogName = _name;
      this.dialogParams = { id: this.xmid };
    },
    /**
     * 初始化数据
     */
    init () {
      this.loading = true;
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      pgcyService.pgcyQuery(this.xmid, this.trueFilterParams)
        .then(rsp => {
          this.pgcyList.rows = rsp.data;
        })
        .catch(err => {
          console.error('获取评估成员信息错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    },
    /**
     * @description: 保存
     * @return {*}
     */
    handleSave (_id) {
      this.loading = true;
      pgcyService.updatePgcy(this.xmid, this.fd)
        .then(rsp => {
          this.$alert('修改成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
          this.init();
          // this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(err => {
          console.error('修改评估评估分工错误！', err);
        });
      this.flag = false;
      this.loading = false;
    },
    /**
     * @description: 删除
     * @return {*}
     */
    handleDel (_row) {
      const _this = this;
      _this.$confirm('是否确认删除此评估成员？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        pgcyService.delPgcy(this.xmid, _row.cyId)
          .then(rsp => {
            _this.$alert('删除成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.init();
          })
          .catch(err => {
            console.error('删除失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {

      });
    }

  },
  created () {
    this.xmid = this.dlParams.id;
    console.log(this.dlParams.type);
    this.init();
  },
  activated () {
    this.xmid = this.dlParams.id;
    this.init();
  }
};

</script>
